import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { useCurrentTrip } from "@/hooks";
import { TRAVELLER_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

type ContactMethod = Partial<{
  id: number;
  priority: number;
  reference: string;
  method: string;
  type: string;
}>;

type ContactMethodResult = {
  success: boolean;

  result: Array<ContactMethod>;
};

type QueryError = {};

const useContactMethodsQuery = (
  options?: UseQueryOptions<
    ContactMethodResult,
    QueryError,
    ContactMethodResult,
    QueryKey
  >
) => {
  const { currentTrip } = useCurrentTrip();
  const cid = currentTrip?.cid;
  const url = `${TRAVELLER_ENDPOINT}/contact-method/traveller/${cid}`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<ContactMethodResult, QueryError>(
    cacheKey,
    async () => {
      if (!cid) throw new Error();
      return fetchWithAuth<ContactMethodResult>(url);
    },
    {
      ...options,
    }
  );
};
export default useContactMethodsQuery;
